import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { businessFormLabel, surveyLabel, surveyList } from "@/lib/utils";
import { useSeller } from "@/api/hooks/use-sellers";
import { Card, CardContent, CardHeader, CardTitle } from "@osmix/ui/card";
import { Separator } from "@osmix/ui/separator";

// The seller's intake survey — read-only. Rendered both on the user detail page
// (the seller's own answers) and on the shop moderation detail, alongside
// <ShopModeration> which owns the verification sections and approve/reject/block
// actions. Both read the same gateway record (api.sellers, keyed by user id);
// this panel renders only its survey slice.

export function SellerSurvey(t0) {
  const $ = _c(10);
  const {
    userId
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    data
  } = useSeller(userId);
  const seller = data ?? null;
  if (!seller) {
    return null;
  }
  const dash = _temp;
  const list = _temp2;
  const survey = seller.survey;
  let t1;
  if ($[0] !== t) {
    t1 = t("sellers.detail.survey");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <CardHeader><CardTitle>{t1}</CardTitle></CardHeader>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== survey || $[5] !== t) {
    t3 = <CardContent className="space-y-3 text-sm">{survey ? <><Row label={t("sellers.fields.businessForm")}>{dash(businessFormLabel(t, survey.businessForm))}</Row><Row label={t("sellers.fields.role")}>{dash(surveyLabel("role", survey.role))}</Row><Row label={t("sellers.fields.categories")}>{surveyList("category", survey.categories)}</Row><Row label={t("sellers.fields.salesChannels")}>{surveyList("channel", survey.salesChannels)}</Row><Separator /><Row label={t("sellers.fields.contactName")}>{dash(survey.contact?.name)}</Row><Row label={t("sellers.fields.city")}>{dash(survey.contact?.city)}</Row><Row label={t("sellers.fields.phone")}>{dash(survey.contact?.phone)}</Row><Row label={t("sellers.fields.preferredContact")}>{dash(surveyLabel("contact", survey.contact?.preferredContact))}</Row><Row label={t("sellers.fields.timeSlots")}>{list(survey.contact?.preferredTimeSlots)}</Row></> : <p className="text-muted-foreground">{t("sellers.detail.noSurvey")}</p>}</CardContent>;
    $[4] = survey;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <Card>{t2}{t3}</Card>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp2(v_0) {
  return v_0 && v_0.length ? v_0.join(", ") : "\u2014";
}
function _temp(v) {
  return v && v.trim() ? v : "\u2014";
}
function Row(t0) {
  const $ = _c(7);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-muted-foreground">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span className="text-right">{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex justify-between gap-4">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}